module.exports = __webpack_public_path__ + "static/media/landing-background-mobile.18afaaa4.jpg";